<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='组织架构管理'></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <el-row :gutter="20" style="margin-top: 20px;margin-left: 20px;">
            <el-col :span="9">
              <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
              <div class="grid-content bg-purple" style="overflow: auto;max-height: 630px;margin-bottom: 20px;margin-top: 10px;">
                <el-tree v-loading="loading" :data="tableData" :default-expanded-keys="treeExpandData" :filter-node-method="filterNode" @node-click="handleNodeClick" accordion node-key="id" ref="tree" highlight-current :props="defaultProps" @check-change="getCheckedItems"></el-tree>
              </div>
            </el-col>
            <el-col :span="15">
              <div class="grid-content bg-purple">
                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">已选择：</label>
                  <div class="col-lg-8">
                    <el-input v-model="form.selectname" readonly=""></el-input>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">名称：</label>
                  <div class="col-lg-8">
                    <el-form-item style="margin-bottom: 0px;" prop="name" :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
                      <el-input v-model="form.name"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">类型：</label>
                  <div class="col-lg-8">
                    <el-select v-model="form.type" style="width: 100%;">
                      <el-option v-for="item in this.$utils.OrgType" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">备注：</label>
                  <div class="col-lg-8">
                    <el-input v-model="form.remark"></el-input>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <label class="col-lg-4 col-form-label">一级目录：</label>
                  <div class="col-lg-8">
                    <el-form-item style="margin-bottom: 0px;">
                      <el-checkbox v-model="form.root"></el-checkbox>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12" style="text-align: center;">
                    <SaveButton :url="addUrl" buttonname="新增" back="0" @saveSucess="saveSucess"></SaveButton>
                    <SaveButton :url="saveUrl" buttonname="修改" back="0" @saveSucess="saveSucess" buttontype="warning"></SaveButton>
                    <el-button type="danger" icon="el-icon-s-order" @click="deleteOrg">删除</el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OrgEdit',
    data() {
      return {
        form: {
          id: '',
          token: '',
          selectname:'',
          name: '',
          type: '',
          remark: '',
          root: false
        },
        filterText: '',
        tableData: [{}],
        treeExpandData:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        loading: true,
        saveUrl: this.$utils.Url.system + '/systemapi/org/update',
        addUrl: this.$utils.Url.system + '/systemapi/org/add'
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      getCheckedItems: function() {
        // this.form.rolepower = this.$refs.tree.getCheckedKeys()
      },
      handleNodeClick: function(data) {
        this.form.id = data.id
        this.form.selectname = data.label
        this.form.name = data.label
        this.form.type = parseInt(data.type)
        this.form.remark = data.remark
      },
      deleteOrg: function() {
        var args = {
          token: this.form.token,
          id: this.form.id
        }
        this.$utils.Delete(this.$utils.Url.system + '/systemapi/org/delete', args, this.form.name, this.reloadOrg)
      },
      saveSucess: function() {
        console.log(this.form)
        this.form.selectname = ''
        this.form.id = ''
        this.form.name = ''
        this.form.type = ''
        this.form.remark = ''
        this.form.root = false
        this.reloadOrg()
      },
      reloadOrg: function() {
        var that = this
        var args = {
          token: this.form.token
        }
        that.loading = true
        this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/org/list', args, function(d) {
          that.tableData = d.Data
          that.loading = false
        }, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      var that = this
      var args = {
        token: this.form.token
      }
      this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/org/list', args, function(d) {
        that.tableData = d.Data
        that.treeExpandData.push(d.Data[0].id)
        that.loading = false
      }, null, null)
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }
</style>
